import React from "react";
import { Users } from "lucide-react";

const formatAmount = (value) =>
  `${Number(value || 0).toLocaleString("fr-FR")} F`;

const StewardTableNavigator = ({
  groups = [],
  onSelect,
  isDarkTheme = true,
}) => (
  <div className="space-y-3" data-testid="steward-table-navigator">
    {groups.map((group) => {
      const openCount = Number(group?.open_tables_count || 0);
      const amountDue = group?.amount_due_incomplete
        ? null
        : Number(group?.amount_due || 0);
      return (
        <button
          key={group.key}
          type="button"
          onClick={() => onSelect?.(group.key)}
          className={`w-full rounded-2xl border p-4 text-left transition hover:border-amber-400 ${
            isDarkTheme
              ? "border-white/10 bg-white/5 text-white"
              : "border-slate-200 bg-slate-50 text-slate-900"
          }`}
        >
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-400/15 text-amber-400">
              <Users size={20} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate font-bold">
                {group.display_name}
              </span>
              {openCount > 0 && (
                <span className="mt-1 block text-sm text-slate-400">
                  {openCount} table{openCount > 1 ? "s" : ""}
                </span>
              )}
            </span>
            {Number(amountDue) > 0 && (
              <span className="font-bold text-amber-400">
                {formatAmount(amountDue)}
              </span>
            )}
          </div>
        </button>
      );
    })}
    {groups.length === 0 && (
      <div className="rounded-2xl border border-dashed border-white/15 px-4 py-8 text-center text-sm text-slate-400">
        Aucun steward.
      </div>
    )}
  </div>
);

export default StewardTableNavigator;
